import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";

//todo - need to look into this. response seems odd
export const sendVerificationEmailRequest = async (
    emailTemplateId: string,
    selectedLanguage: string,
    recipient: string,
    url: string
) => {
    const route = apiRoutes.serviceConfiguration.selfService.email;

    const body = {
        emailTemplateID: emailTemplateId,
        language: selectedLanguage,
        recipients: [recipient],
        url: url
    };

    const { data } = await handleRequestWithBody(RequestTypes.POST, route, body);
    if (data?.code === 200) {
        return data;
    }

    return null;
};